import { packageType, packageTypeStr } from "@/types";

export const receiptColumns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "快递单号",
    dataIndex: "expressNo",
    key: "expressNo",
  },
  {
    title: "采购单号",
    dataIndex: "purchaseNo",
    key: "purchaseNo",
    customRender: (text, record, index) => {
      return text||'-';
    },
  },
  // {
  //   title: '商品类目',
  //   dataIndex: 'category',
  //   key: 'category',
  //   ellipsis: true,
  // },
  // {
  //   title: "入库单类型",
  //   dataIndex: "purchaseType",
  //   key: "purchaseType",
  //   customRender: (text, record, index) => {
  //     return record.status==99?'-':[record.bizType == 1 ? "档口采购单" : "线上采购单", "OEM大货单", "OEM样品单"][text];
  //   },
  // },
  {
    title: "订单来源",
    dataIndex: "systemSource",
    key: "systemSource",
    customRender: (text, record, index) => {
      return packageTypeStr[text];
    },
  },
  {
    title: "重量",
    dataIndex: "weight",
    key: "weight",
    width: 150,
    scopedSlots: {
      customRender: "weightAction",
    },
  },
  {
    title: "箱数",
    dataIndex: "boxAmount",
    key: "boxAmount",
    width: 150,
    scopedSlots: {
      customRender: "boxAmountAction",
    },
  },
  {
    title: "签收状态",
    dataIndex: "receiptStatus",
    key: "receiptStatus",
    ellipsis: true,
    customRender: (text, record, index) => {
      return record.status == 99 ? "异常签收" : "正常签收";
    },
  },
  {
    title: "签收类型",
    dataIndex: "receiptType",
    key: "receiptType",
    ellipsis: true,
    customRender: (text, record, index) => {
      // return receiptTypes[text]
      return record.status == 1 ? "采购单签收" : record.status == 2 ? "调拨单签收" : "-";
    },
  },
  {
    title: "是否仓库调拨",
    dataIndex: "isTransfer",
    key: "isTransfer",
    ellipsis: true,
    customRender: (text, record, index) => {
      // return ['否', '是'][text]
      return record.status==2?'是':'否';
    },
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
    width: 200,
    scopedSlots: {
      customRender: "remarkAction",
    }
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "id",
    width: 160,
    scopedSlots: {
      customRender: "action",
    },
    fixed: "right",
  },
];
const receiptStatus = ["正常签收", "异常签收"];
const receiptTypes = ["调拨单签收", "采购单签收"];

/**
 * test data
 * */
export const testDataSource = [
  {
    id: 0,
    remark: "质检要求备注，质检要求备注，质检要求备注，质检要求备注。",
    isTransfer: 0,
    receiptType: 0,
    receiptStatus: 0,
    receiptTime: "2022-03-28 10:30:00",
    pkgType: 0,
    category: "衣服",
    purchaseNo: "",
    expressNo: "SF202203281040",
  },
];
